import * as Moment from "moment"

import BlogPost from "./BlogPost"

export default async function fetchBlogPosts(): Promise<BlogPost[]> {
    const response = await fetch("https://public-api.wordpress.com/rest/v1.1/sites/blog.tpersson.io/posts?number=2")
    if (!response.ok) {
        return []
    }

    const doc = await response.json()
    return doc.posts.map((it: any) => ({
        url: it.URL,
        date: Moment(it.date),
        title: it.title
    }))
}


// WEBPACK FOOTER //
// ./src/modules/frontpage/fetchBlogPosts.ts